import type { OneText } from '../../global';

declare let onetext : OneText;

const loader = async () : Promise<void> => {
    const { register } = onetext.popup;
    const { StandardPopup } = await import('./popups');

    register({ externalID: 'standard', Component: StandardPopup });
    register({ externalID: 'spin_discount', Component: StandardPopup });
    register({ externalID: 'spin_shipping', Component: StandardPopup });
    register({ externalID: 'spin_free', Component: StandardPopup });
    register({ externalID: 'spin_discount_mint', Component: StandardPopup });
    register({ externalID: 'spin_shipping_mint', Component: StandardPopup });
    register({ externalID: 'spin_free_mint', Component: StandardPopup });
    register({ externalID: 'open_discount', Component: StandardPopup });
    register({ externalID: 'open_shipping', Component: StandardPopup });
    register({ externalID: 'open_free', Component: StandardPopup });

    register({ externalID: 'spin_discount_v2', Component: StandardPopup });
    register({ externalID: 'spin_cable_claim_offer', Component: StandardPopup });
    register({ externalID: 'spin_cable_captcha', Component: StandardPopup });
    register({ externalID: 'open_discount_v2', Component: StandardPopup });
    register({ externalID: 'open_claim_offer', Component: StandardPopup });
    register({ externalID: 'open_captcha', Component: StandardPopup });
    register({ externalID: 'open_discount_v4', Component: StandardPopup });

    register({ externalID: 'spin_cable_bright_color_v2', Component: StandardPopup });
    register({ externalID: 'open_discount_spin_to_win', Component: StandardPopup });
    register({ externalID: 'spin_cable_spin_to_win', Component: StandardPopup });
};

window.onLoadOneText ??= [];

window.onLoadOneText.push({
    name:       sdk.brand?.name,
    commitHash: sdk.commitHash,
    loader
});
